export default __webpack_public_path__ + "static/media/dialogue-videos.f8f5a3da.svg";